import React, { useEffect } from 'react';
import GrantMathLavaLamp from './GrantMathLavaLamp';
import globalHeartbeat from '../utils/globalHeartbeatAudio';

/**
 * Mission Statement Page - Second Landing Page
 * Even deeper zoom (6x) into collective consciousness
 * Explains the ONE reason this exists
 */
const MissionLanding = ({ onContinue }) => {
  useEffect(() => {
    // Initialize heartbeat
    if (globalHeartbeat) {
      globalHeartbeat.setEnabled(true);
    }
  }, []);

  return (
    <div 
      className="min-h-screen flex items-start justify-start relative overflow-hidden cursor-pointer"
      onClick={onContinue}
    >
      {/* Ultra Deep Zoom - 6x into the core */}
      <div 
        className="absolute inset-0" 
        style={{ 
          transform: 'scale(6)', // 50% more than cinematic (4x → 6x)
          transformOrigin: 'center',
          filter: 'blur(1.5px)',
          opacity: 0.85
        }}
      >
        <GrantMathLavaLamp params={{ 
          energy: 0.6, 
          warmth: 0.75, 
          complexity: 0.65, 
          harmony: 0.85, 
          expansion: 0.6 
        }} />
      </div>

      {/* Ultra Black Vignette - Strong edges */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.85) 35%, rgba(0,0,0,0.98) 100%)'
        }}
      />

      {/* Content - Top-left, theatrical, old-fashioned */}
      <div className="relative z-10 px-8 md:px-12 pt-20 md:pt-32 max-w-2xl animate-fadeFromCenter">
        <div 
          className="space-y-8 leading-relaxed"
          style={{ 
            fontFamily: '"Cormorant Garamond", "Libre Baskerville", serif',
            color: '#F5F5DC', // Warm beige
            textShadow: '0 0 40px rgba(245, 245, 220, 0.3)',
            fontSize: '1.125rem',
            fontWeight: '300',
            lineHeight: '1.8'
          }}
        >
          <p className="text-2xl md:text-3xl font-light italic" style={{ color: '#FFF8F0' }}>
            This experience exists for one reason.
          </p>

          <p className="text-lg md:text-xl">
            To orchestrate a <span className="font-medium" style={{ color: '#FFE4B5' }}>planetary family of families</span>.
          </p>

          <p className="text-lg md:text-xl">
            A guild of family guilds.
          </p>

          <p className="text-base md:text-lg opacity-90">
            Mostly <span className="italic">face-to-face</span> and <span className="italic">hand in hand</span> with those you trust.
          </p>

          <p className="text-base md:text-lg opacity-90">
            And here, in the digital reality, M.ai.ry is a <span className="font-medium" style={{ color: '#FFE4B5' }}>family aligned instrument</span>—
          </p>

          <p className="text-xl md:text-2xl font-light italic text-center my-8" style={{ color: '#FFF8F0' }}>
            helping our songs align.
          </p>

          <div className="text-center mt-16">
            <div 
              className="text-sm animate-pulse opacity-60"
              style={{ fontStyle: 'italic' }}
            >
              [ continue ]
            </div>
          </div>
        </div>
      </div>

      {/* Cute blurb about the orb - RIGHT side */}
      <div 
        className="absolute right-8 md:right-16 top-1/2 transform -translate-y-1/2 max-w-xs hidden md:block z-20"
        style={{
          animation: 'fadeFromCenter 3s ease-out 1s backwards'
        }}
      >
        <div 
          className="bg-black/60 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-6 text-xs leading-relaxed"
          style={{ 
            fontFamily: '"Cormorant Garamond", serif',
            color: '#E8E8D0',
            textShadow: '0 0 20px rgba(232, 232, 208, 0.2)'
          }}
        >
          <p className="text-amber-400/60 text-[10px] uppercase tracking-wider mb-3 font-mono">
            About the Visual
          </p>
          <p className="mb-3">
            The orb you see is derived from mathematician Grant Hicks' dimensional formula.
          </p>
          <p className="mb-3 text-amber-300/80 font-medium text-center font-mono text-sm">
            R = α·π/(2·(−θ+3π))
          </p>
          <p className="mb-3">
            It's a living fractal pattern—breathing in real-time based on the collective inputs and outputs of everyone using this experience.
          </p>
          <p className="text-amber-400/50 italic text-[11px]">
            You are seeing the emotional state of the whole, right now.
          </p>
        </div>
      </div>

      {/* Bottom hint */}
      <div 
        className="absolute bottom-8 left-8 text-xs italic opacity-10"
        style={{ 
          fontFamily: '"Cormorant Garamond", serif',
          color: '#F5F5DC'
        }}
      >
        no more isms. just us.
      </div>
    </div>
  );
};

export default MissionLanding;
